/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {NoteId} from "./noteId.zod";

export const NoteDto = zod.object({
  noteId: NoteId,
  createdAt: zod.iso.datetime({offset: true}),
  updatedAt: zod.iso.datetime({offset: true}),
  title: zod.string(),
  content: zod.string(),
});

export type NoteDto = zod.input<typeof NoteDto>;
export type NoteDtoOutput = zod.output<typeof NoteDto>;
